import React from 'react';

// FundMaster Components
import { Header } from './Header';
import { FundMasterHeroSection } from './FundMasterHeroSection';
import { FundMasterApproachSection } from './FundMasterApproachSection';
import { ManagerSection } from './ManagerSection'; // Same manager section
import { FundMasterBenefitsSection } from './FundMasterBenefitsSection';
import { FundMasterContactSection } from './FundMasterContactSection';
import { Footer } from './Footer';

export const FundMasterPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <FundMasterHeroSection />
      <FundMasterApproachSection />
      <ManagerSection />
      <FundMasterBenefitsSection />
      <FundMasterContactSection />
      <Footer />
    </div>
  );
};